<template>
  <v-container fluid>
    <template>
      <v-card :loading="loading">
        <v-card-title>
          <h2>
            <v-btn
              class="mx-2"
              icon
              text
              small
              :to="{ name: 'funcionario-list' }"
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <span v-if="loading">Carregando...</span>
            <template v-else>
              <span v-if="tituloNovo">Novo funcionário</span>
              <span v-else
                >Alterar funcionário: {{ matricula }} - {{ nome }}</span
              >
            </template>
          </h2>
        </v-card-title>
        <form @submit.prevent="submitForm">
          <v-tabs v-model="tab" grow>
            <v-tab>
              <v-icon
                left
                color="error"
                v-if="
                  $v.matricula.$invalid ||
                    $v.nome.$invalid ||
                    $v.email.$invalid ||
                    $v.telefone.$invalid
                "
                class="mdi mdi-alert-circle"
              ></v-icon>
              <span>Geral</span>
            </v-tab>
            <v-tab>Endereço</v-tab>
            <v-tab>Documentos</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-card-text>
                <v-select
                  v-model="id_empresa"
                  label="Empresa"
                  :items="empresas"
                  item-text="nome_fantasia"
                  item-value="id"
                />
                <v-text-field
                  v-model="matricula"
                  :error-messages="matriculaErrors"
                  :counter="10"
                  label="Matrícula"
                  required
                  @input="$v.matricula.$touch()"
                  @blur="$v.matricula.$touch()"
                ></v-text-field>
                <v-text-field
                  v-model="nome"
                  :error-messages="nomeErrors"
                  :counter="40"
                  label="Nome"
                  required
                  @input="$v.nome.$touch()"
                  @blur="$v.nome.$touch()"
                ></v-text-field>
                <v-text-field
                  v-model="email"
                  :error-messages="emailErrors"
                  :counter="140"
                  label="E-mail"
                  @input="$v.email.$touch()"
                  @blur="$v.email.$touch()"
                ></v-text-field>
                <v-text-field
                  v-model="telefone"
                  v-mask="'phone'"
                  :error-messages="telefoneErrors"
                  maxlength="15"
                  label="Telefone"
                  @input="$v.telefone.$touch()"
                  @blur="$v.telefone.$touch()"
                ></v-text-field>
              </v-card-text>
            </v-tab-item>
            <v-tab-item>
              <v-card-text>
                <endereco-form v-model="endereco" />
              </v-card-text>
            </v-tab-item>

            <v-tab-item>
              <lista-documentos
                url-base="funcionarios"
                :id-proprietario="id"
                v-model="documentos"
                alterar
              />
            </v-tab-item>
          </v-tabs-items>

          <v-card-actions>
            <v-btn depressed color="primary" @click="submit" :loading="loading"
              >Salvar</v-btn
            >
          </v-card-actions>
        </form>
      </v-card>
    </template>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { required, maxLength, numeric } from "vuelidate/lib/validators";
import ListaDocumentos from "../components/documentos/ListaDocumentos";
import EnderecoForm from "../components/enderecos/EnderecoForm";

export default {
  components: { ListaDocumentos, EnderecoForm },
  mixins: [validationMixin],

  validations: {
    matricula: { required, maxLength: maxLength(10), numeric },
    nome: { required, maxLength: maxLength(40) },
    email: { maxLength: maxLength(140) },
    telefone: { maxLength: maxLength(20) },
  },

  data() {
    return {
      id: "",
      id_empresa: this.$store.state.usuarios.empresaAtiva.id,
      matricula: "",
      nome: "",
      email: "",
      telefone: "",
      tituloNovo: true,
      tab: null,
      loading: false,
      select: null,
      documentos: [],
      endereco: {
        endereco: "",
        numero: "",
        complemento: "",
        bairro: "",
        id_cidade: null,
        cep: "",
        cidade: null,
      },
    };
  },

  computed: {
    matriculaErrors() {
      const errors = [];
      if (!this.$v.matricula.$dirty) return errors;
      !this.$v.matricula.required && errors.push("Matrícula é Obrigatório.");
      !this.$v.matricula.maxLength && errors.push("Somente 10 caracteres.");
      !this.$v.matricula.numeric && errors.push("Somente número");
      return errors;
    },
    nomeErrors() {
      const errors = [];
      if (!this.$v.nome.$dirty) return errors;
      !this.$v.nome.required && errors.push("Matrícula é Obrigatório.");
      !this.$v.nome.maxLength && errors.push("Somente 10 caracteres.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.maxLength && errors.push("Somente 40 caracteres.");
      return errors;
    },
    telefoneErrors() {
      const errors = [];
      if (!this.$v.telefone.$dirty) return errors;
      !this.$v.telefone.maxLength && errors.push("Somente 20 caracteres.");
      return errors;
    },
    ...mapState({
      empresas: (state) => state.empresa.empresas,
    }),
  },

  methods: {
    async submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loading = true;
        try {
          const funcionario = await this.$store.dispatch("funcionario/gravar", {
            id: this.id,
            id_empresa: this.id_empresa,
            matricula: parseInt(this.matricula),
            nome: this.nome,
            email: this.email,
            telefone: this.telefone,
            ...this.endereco,
          });
          if (this.documentos.length > 0) {
            await this.$store.dispatch("documento/gravar", {
              urlBase: "funcionarios",
              IDProprietario: funcionario.id,
              documentos: this.documentos,
            });
          }
          this.$router.replace({ path: "lista", name: "funcionario-list" });
        } finally {
          this.loading = false;
        }
      }
    },
  },
  async mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Cadastro de funcionários",
    });
    this.loading = true;
    this.$store.dispatch("empresa/listar");
    this.id = "";
    if (this.$route.params.id) {
      var id = this.$route.params.id;
      this.id = id;
      this.tituloNovo = false;

      try {
        var response = await this.$store.dispatch(
          "funcionario/carregarFuncionario",
          id
        );
        this.id_empresa = response.data.id_empresa;
        this.matricula = response.data.matricula;
        this.nome = response.data.nome;
        this.email = response.data.email;
        this.telefone = response.data.telefone;
        this.endereco = {
          endereco: response.data.endereco,
          numero: response.data.numero,
          complemento: response.data.complemento,
          bairro: response.data.bairro,
          id_cidade: response.data.id_cidade,
          cep: response.data.cep,
          cidade: response.data.cidade,
        };
      } catch (err) {
        //deu pau
      }
    }
    this.loading = false;
  },
};
</script>
